'use client'

import Link from 'next/link'
import { useLocale, useTranslations } from 'next-intl'
import { useGetCityBrandsQuery } from '@/api/brands/get-brand-query'
import { useGetCityQuery } from '@/api/cities/get-city-query'
import { Locale } from '@/setup/locales'
import { getLinkHref } from '@/setup/routing'
import { cn } from '@/utils/styles/cn'

interface IRestaurantCityBrandsLinkProps {
    citySlug: string
    className?: string
}

export const RestaurantCityBrandsLink = ({
    citySlug,
    className,
}: IRestaurantCityBrandsLinkProps) => {
    const locale = useLocale() as Locale
    const t = useTranslations()

    // Prefetched and hydrated by the server component, so this reads from cache.
    const { data: brandsData } = useGetCityBrandsQuery(citySlug)
    const { data: cityData } = useGetCityQuery(citySlug)

    if (!brandsData?.data?.length) return null

    const cityName = cityData?.data?.name ?? citySlug

    return (
        <Link
            href={getLinkHref(
                { pattern: '/restaurants/[citySlug]/brands', params: { citySlug } },
                locale
            )}
            className={cn(
                'text-gray-500 text-center md:text-[14px] text-[12px] underline w-fit',
                // py-3 rather than bare text: an 18px-tall link is well under a
                // comfortable tap target.
                'py-3 px-2 min-h-11 flex items-center hover:text-black transition-colors',
                className
            )}
        >
            {t('restaurants.brands.cityLink', { cityName })}
        </Link>
    )
}
